import React from 'react';
import PropTypes from 'prop-types';
import CIcon from '@coreui/icons-react';

const Card = (props) => {
  const { title = 'Titulo', description, icon, onClick } = props;

  return (
    <div className='col-md-4 mb-3' onClick={onClick}>
      <div className='card card-body shadow clickable'>
        <div className='row'>
          <div className='col-sm-2 m-auto p-2'>
            <CIcon name={icon} size='2xl' className='w-100' />
          </div>
          <div className='col-sm-10 text-sm-left text-center pl-0'>
            <h5>{title}</h5>
            <span className='text-muted'> {description} </span>
          </div>
        </div>
      </div>
    </div>
  );
};

Card.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func
};

export default Card;
